import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ImportIcon from '../../../../../components/icons/ImportIcon';
import Angle from '../../../../../components/global/Angle';
import Button from '../../../../../components/global/Button';
import { postNativeAppCardsContactsSelect } from '../../../../native-bridge/native-apps-interface';

const propTypes = {
  className: PropTypes.string,
};

const AddressListItemContactsImportButton = ({ className }) => {
  const classes = classNames({
    'address-list-action-button': true,
    'address-list-item-import-button': true,
    [className]: !!className,
  });

  return (
    <Button
      btnStyle="reset"
      className={classes}
      onClick={() => postNativeAppCardsContactsSelect()}
    >
      <ImportIcon /> Import from contacts
      <Angle direction="right" />
    </Button>
  );
};

AddressListItemContactsImportButton.propTypes = propTypes;

export default AddressListItemContactsImportButton;
